<i18n lang='yml' src='../i18n/Calendar.yml'></i18n>
<template>

  <div v-if="this.firstDayOfWeek">
    <div class="border-bottom" v-if="admin == 'true'">
      <hr />
      <div class="row selected_session">
        <div class="col-xs-12 px-2 pl-2">
          <span class="session-icon" >
            <font-awesome-icon :icon="['far', 'calendar-check']"/>
          </span>
          <h6 class="heading-page">
            {{$t('selected_sessions')}} 
          </h6>
          <div class="session-list">
            <div v-if="sessions.length > 0">
              <ol >
                <li class="row" v-for="session in sessions" :key="session.id">
                  <span class="col-xs-12">{{formatDate(session.date)}} {{formatTime(session.start_time)}} - {{formatTime(session.end_time)}} {{session.sub_location.name[locale]}}</span>
                  <button class="btn col-xs-12" @click="removeSession(session.id)"> <font-awesome-icon :icon="['fas', 'times']" /> {{$t('remove')}}</button>
                </li>
              </ol>
              <button href="#" @click="nextStep" class="btn btn-md btn-success">{{$t('book_sessions')}}</button>
            </div>
            <p v-else > {{$t('no_sessions')}}</p>
          </div>
        </div>
      </div>
    </div>
    <hr v-if="admin == 'false' || edit_permission == 'false'" />
    <div class="cal-key">
      <ul>
        <li>
          <span class="cal-sitting cal-available">
            <div class="sitting-info">
              {{$t('available')}}
            </div>
          </span>
        </li>
        <li>
          <span class="cal-sitting cal-unavailable" v-if="admin == 'true' || edit_permission == 'true'">
            <div class="sitting-info">
              {{$t('not_available')}}
            </div>
          </span>
        </li>
        <li>
          <span class="cal-sitting cal-selected">
            <div class="sitting-info">
              {{$t('selected')}}
            </div>
          </span>
        </li>
        <li>
          <span class="cal-sitting cal-past" title="Completed sitting" v-if="admin == 'true' || edit_permission == 'true'">
            <div class="sitting-info">
             {{$t('past')}}
            </div>
          </span>
        
        </li>
      </ul>
    </div>

    <div class="vue-calendar-wrapper">
      <div class="calendar-component">
        <div class="calendar-header">
          <ul class="cal-header-top">
            <li class="arrows-nav">
              <a href="#" @click.prevent="getPreviousWeek()">
                <font-awesome-icon :icon="['fas', 'chevron-left']"/>   
                <span>{{$t('prev')}}</span>
              </a>
            </li>
            <li style="" class="cal-75" :class="displayCalendar ? 'show' : ''">
              <label for="month-picker" class="sr-only">{{$t('month_picker')}}</label>
              <flat-pickr id="month-picker" @on-close="onMonthChanged" :config="config" v-model='currentMonth'></flat-pickr>            
              <a href="#" class="month-container" @click.prevent="toggleCalendar">
                <span class="mr-1">{{getMonthYear(currentMonth)}}</span>
                <font-awesome-icon :icon="['far', 'calendar-alt']"/>
              </a>
              
            </li>
            <li class="arrows-nav">
              <a href="#" @click.prevent="getFollowingWeek()">
                <span class>{{$t('next')}}</span>
                <font-awesome-icon :icon="['fas', 'chevron-right']"/>  
              </a>
            </li>
          </ul>
        </div> 
      </div>
      <div v-for="subLocation in selectedSubLocations" :key="subLocation.id" >
        <div class='calendar-btn-row' v-if="context == 'booking'">
          <div class="action-row">
            <p class="status-bold d-flex">{{subLocation.name[locale]}}</p>
            <a href="#" class="first_available_sitting" @click.prevent="goToDate(subLocation.first_available_sitting.date)" v-if="subLocation.first_available_sitting">{{ $t('first_available_sitting') }} {{formatDateNumeric(subLocation.first_available_sitting.date)}}</a>
          </div>
          <button @click="removeLocation(subLocation.id)" :aria-label="$t('remove')" class="btn btn-warning ml-auto">
            <span class="d-none d-md-inline">{{$t('remove')}}</span>
            <font-awesome-icon :icon="['fa', 'times']"/>
          </button>
        </div>

        <week       
          :weekdays="currentWeekdays()" 
          :events="events"
          :sub_location_path="sub_location_path"
          :sub_location="subLocation"
          :context='context' 
          :sessions="sessions"
          :details="selectedSession"
          :edit_permission="edit_permission || admin"
          :booking_details="booking_details"
          :sitting_path="`${context == 'booking' ? `/en/c/exam_centres/${subLocation.container_id}/sub_locations/${subLocation.id}/sittings` : base_path }`" 
          @selected="setSessionInfo" 
          :locale="locale"
          :session_open="selectedSession"
          @addToCart="addToCart"
          @nextStep="nextStep"
          :type="type"
          @clear="clearSession"
          :selectedSession="selectedSession"
          :time_format_en="time_format_en" :time_format_fr="time_format_fr"
        />
        <div v-if="selectedSession && selectedSession.sub_location_id === subLocation.id" class="d-none d-md-block">
          <session-details 
          @nextStep="nextStep"
          :booking_details="booking_details"
          :details="selectedSession"
          :context="context"
          :selectedSession="selectedSession"
          :sessions="sessions"
          :locale="locale"
          @clear="clearSession"
          @addToCart="addToCart"
          :admin="edit_permission || admin"
          :type="type"
          :time_format_en="time_format_en" :time_format_fr="time_format_fr"
          />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import SessionDetails from './SessionDetails.vue'
import week from './Week.vue'
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect/index.js";
import 'flatpickr/dist/plugins/monthSelect/style.css' 
import {French} from 'flatpickr/dist/l10n/fr.js';
import {formatDate, formatTime} from '../../../shared/typescripts/dates.ts'

    Date.prototype.stdTimezoneOffset = function() {
        var jan = new Date(this.getFullYear(), 0, 1);
        var jul = new Date(this.getFullYear(), 6, 1);
        return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
    }

    Date.prototype.dst = function() {
        return this.getTimezoneOffset() < this.stdTimezoneOffset();
    }


    export default {
        props: [
          'locale' , 'base_path', 'location',  'selected_sub_locations',  'context', 'sub_location_path', 'booking_details', 'edit_permission', 'admin', 'type', 'time_format_en', 'time_format_fr'
        ],
        components: {
          'week': week,
          'session-details' :SessionDetails,
        },
        data() {
        return {
            events: [],
            selectedSubLocations: [],
            config: {
              enableTime: false,
              inline: true,
              reset: (this.locale=='fr') ? 'Réinitialiser' : 'Reset',
              locale: (this.locale=='fr') ? French : 'en',
              defaultDate: new Date(),
              plugins: [
                new monthSelectPlugin({
                }),
              ],
              onReady: function ( dateObj, dateStr, instance,) {
                instance.setDate('today', true)
                const $clear = $( `<div class="flatpickr-clear"><button class="flatpickr-clear-button btn btn-sm btn-outline-secondary mb-2"><font-awesome-icon :icon="['fas', 'chevron-right']"/>${instance.config.reset}</button></div>` )
                  .on( 'click', () => {
                    instance.setDate('today', true)
                    instance.close();
                  } )
                  .appendTo( $( instance.calendarContainer ) );
              }
            },
            currentDate: null,
            currentMonth: null,
            monthNames: ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'],     
            firstDayOfWeek: null,
            endOfWeek: null,
            lengthOfDay: 25*60*60*1000,  // multiplying by 25 instead of 24 due to Day Light Savings 
            selectedSession: null,
            sessions: [],
            displayCalendar: false,
            maxDate: new Date().setFullYear(new Date(). getFullYear() + 1)
          }
        },
        watch: {  
           selected_sub_locations: {
              handler(newValue) {
                this.selectedSubLocations = newValue

                if (this.type == 'edit' && this.booking_details) {
                  this.sessions = this.booking_details.sittings
                }
              },
              deep: true,
              immediate: true
            },
            
        },
        methods: {
          goToDate(date) {
            this.currentDate = new Date(date)
            this.setFirstDayOfWeek()
            this.clearSession()
          },
          getDate(date, daysAway) {
            let newDate = new Date(date.getTime() + daysAway * this.lengthOfDay)
            newDate.setHours(0)
            return newDate
          },
          getPreviousWeek() {
            event.preventDefault()
            this.currentDate = this.getDate(this.currentDate, -7); 
            this.currentMonth = this.currentDate; 
            this.setFirstDayOfWeek()
            this.clearSession()
          },
          getFollowingWeek() {
            event.preventDefault()
            this.currentDate = this.getDate(this.currentDate, 7);
            this.currentMonth = this.currentDate; 
            this.setFirstDayOfWeek()
            this.clearSession()
          },
          addToCart() {
            // Double check since only admins should be able to add multiple to cart
            if(this.admin == 'true') {
              this.sessions.push(this.selectedSession)
            }
            else {
              this.nextStep()
            }
          },
          nextStep() {
            if(this.sessions.length == 0 && this.selectedSession){
              this.sessions.push(this.selectedSession);
            }
            this.$emit('sittingChange', this.sessions)
            this.$emit('nextStep')
          },
          setFirstDayOfWeek() {
            this.firstDayOfWeek = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), this.currentDate.getDate() - this.currentDate.getDay())
          },      

          currentWeekdays() {
            let dateToUse = this.firstDayOfWeek;
            let weekdays = []
            for(let i=1; i <= 5; i+=1) {
              weekdays.push(this.getDate(dateToUse, i))
            }
            return weekdays
          },

          getNextWorkDay(date) {
            let d = new Date(+date);
            let day = d.getDay() || 7;

            d.setDate(d.getDate() + (day > 4? 8 - day : 1));
            return d;
          },

          toggleCalendar() {
            this.displayCalendar = !this.displayCalendar
          },

          onMonthChanged(selectedDates, dateStr, instance) {
            let dateSelected = selectedDates.length > 0 ? selectedDates[0] : ''
            this.currentDate = dateSelected

            this.currentMonth = dateSelected
            this.setFirstDayOfWeek()
            this.displayCalendar = false
          },

          getMonthYear() {
            let firstDayOfWorkWeek = this.getNextWorkDay(this.firstDayOfWeek)
            let lastDayOfWorkWeek = this.getDate(firstDayOfWorkWeek, 4)
           
            if (firstDayOfWorkWeek && lastDayOfWorkWeek) {
              const startOfWeekYear = firstDayOfWorkWeek.getFullYear()
              const endOfWeekYear = lastDayOfWorkWeek.getFullYear()
            
              const startOfWeekMonth = this.monthNames[firstDayOfWorkWeek.getMonth()]
              const endOfWeekMonth = this.monthNames[lastDayOfWorkWeek.getMonth()]       
              if (startOfWeekYear == endOfWeekYear) {
                if (startOfWeekMonth == endOfWeekMonth) {
                  return `${this.$i18n.t(`${startOfWeekMonth}_long`)} ${startOfWeekYear}`
                } else {
                  return `${this.$i18n.t(`${startOfWeekMonth}_short`)} - ${this.$i18n.t(`${endOfWeekMonth}_short`)} / ${startOfWeekYear}`
                }
              } else {
                return `${this.$i18n.t(`${startOfWeekMonth}_short`)} ${startOfWeekYear} / ${this.$i18n.t(`${endOfWeekMonth}_short`)} ${endOfWeekYear}` 
              }
            }
          },
          setSessionInfo(item) {
            this.selectedSession = item
          },
          clearSession() {
            this.selectedSession = null
          },
          removeLocation(id) {      
            this.$emit('removeLocation', {"location_id": id})     
          },
          getDateTime(date, time) {
            let eventStartTime = new Date(time)
            let eventDate = new Date(date)
            eventDate.setHours(eventStartTime.getHours())
            eventDate.setMinutes(eventStartTime.getMinutes())
            return eventDate
          },
          formatDate(dateString) {
            const options = { weekday: 'long', month: 'long', day: 'numeric'};
            return formatDate(dateString, options, this.$i18n.locale)
          },
          formatDateNumeric(dateString) {
            return formatDate(dateString)
          },
          formatTime: function (date) {
            let format = this.locale == 'en' ? this.time_format_en : this.time_format_fr
            return formatTime(date, format)
          },
          removeSession(id) {
            let index = this.sessions.findIndex(val => val.id === id)
            if (index !== -1) {
              this.sessions.splice(index, 1)
            }
          },

        },
        mounted () {
          this.$i18n.locale = this.locale;
          this.currentDate = new Date()
          this.currentMonth = new Date()
          this.isDisabled = true
          this.setFirstDayOfWeek()
          if(this.context == 'sub_location') {
            this.selectedSubLocations = JSON.parse(this.selected_sub_locations)
          }
          if (this.booking_details && this.booking_details.session_details) {
            this.booking_details.session_details.map((sess) => {
              this.sessions.push(sess.session)
            })
          }
        }
    }
</script>

